import getModalActions from '../../../../shared/modals/getModalActions';
import { MODAL_NAMES } from '../constants';


export const {
  showAction: showDeleteScenarioMemberModal,
  hideAction: hideDeleteScenarioMemberModal,
} = getModalActions(MODAL_NAMES.DeleteScenarioMemberModal);
